import React from "react";
import Markdown from "../../markdown";

interface ContentItem {
  subTitle: string;
  richText: string;
}

interface Props {
  items: ContentItem[];
}

const TextOnlyBannerContent: React.FC<Props> = ({ items }) => {
  return (
    <div data-testid="ctr-text-only-banner-markdown-content" data-ffid="ctr-text-only-banner-markdown-content">
      {items.map((item, index) => (
        <div key={item.subTitle} className="mb-24">
          <h3 data-testid={`lbl-text-only-banner-markdown-content-sub-title-${index}`} data-ffid={`lbl-text-only-banner-markdown-content-sub-title-${index}`} className="text-16 lg:text-28 font-normal text-[#5c5c5c]">
            {item.subTitle}
          </h3>
        <div data-testid={`ctr-text-only-banner-markdown-content-section-${index}`} data-ffid={`ctr-text-only-banner-markdown-content-section-${index}`}>
          <Markdown
            markdown={item.richText}
            className="prose max-w-none prose-p:text-left prose-p:text-[#5C5C5C] prose-p:text-14 prose-p:lg:text-16 prose-p:w-full prose-ul:list-none prose-li:relative prose-li:text-14 prose-li:lg:text-16 prose-li:pl-15 prose-li:before:absolute prose-li:before:left-0 prose-li:before:top-12 prose-li:before:size-4 prose-li:before:rounded-full prose-li:before:bg-[#5c5c5c] prose-a:text-[#0B57D0] prose-a:no-underline prose-a:font-normal prose-a:hover:text-[#0B57D0]"
          />
          </div>
        </div>
      ))}
    </div>
  );
};

export default TextOnlyBannerContent;